// Which sign-in provider the Vue admin starts: resolved at runtime from /public/auth/config
// (Replane auth.provider), accepted only when this build carries that provider's public
// coordinates. Kept free of Vue / SDK imports so it can be tested on its own.
const PROVIDERS = ['auth0', 'keycloak']

// The build only carries each provider's PUBLIC coordinates; which one is ACTIVE is a runtime
// decision (Replane auth.provider, served by /public/auth/config), like the React client's.
// Without this the admin stayed on whatever VUE_APP_AUTH_PROVIDER the image was built with.
let serverProvider = null

// A provider can start only if this build has its public config.
const hasConfigFor = (name) => {
    if (name === 'keycloak') return Boolean(process.env.VUE_APP_AUTH_ISSUER && process.env.VUE_APP_AUTH_CLIENTID)
    if (name === 'auth0') return Boolean(process.env.VUE_APP_AUTH0_DOMAIN && process.env.VUE_APP_AUTH0_CLIENTID)
    return false
}
const buildProvider = () => {
    const name = String(process.env.VUE_APP_AUTH_PROVIDER || 'auth0').trim().toLowerCase()
    return PROVIDERS.includes(name) ? name : 'auth0'
}
export const provider = () => serverProvider || buildProvider()
export const isKeycloak = () => provider() === 'keycloak'

/**
 * Ask the server which provider is active before the auth plugin is installed. Bounded by a
 * timeout and never throws: any failure keeps the build's default rather than blocking sign-in.
 */
export const resolveAuthProvider = async ({ timeoutMs = 3000 } = {}) => {
    const api = process.env.VUE_APP_API
    if (!api) return provider()
    const controller = new AbortController()
    const timer = setTimeout(() => controller.abort(), timeoutMs)
    try {
        const res = await fetch(`${api}/public/auth/config`, { signal: controller.signal })
        if (res.ok) {
            const body = await res.json()
            const name = String((body?.getAuthConfig ?? body)?.provider ?? '').trim().toLowerCase()
            if (PROVIDERS.includes(name) && hasConfigFor(name)) serverProvider = name
        }
    } catch {
        // Unreachable or timed out — the build's default stands.
    } finally {
        clearTimeout(timer)
    }
    return provider()
}

